// LLM generated - Model Claude 4 Sonnet
import React from 'react';
import { createStyles } from '@mantine/core';
import Dialog from '~/domains/design-system/components/Dialog/Dialog';
import DialogContainer from '~/domains/design-system/components/Dialog/DialogContainer';
import { ContestChat } from '../ContestChat';
import type { ContestChatModalProps } from '../types';

const useStyles = createStyles(() => ({
  chatContainer: {
    padding: 0,
    width: '100%',
    height: '100%',
    maxHeight: '85vh',
  },
}));

export default function ContestChatModal({
  isOpen,
  onClose,
  toggleChatAction,
}: ContestChatModalProps) {
  const { classes } = useStyles();

  return (
    <DialogContainer isOpen={isOpen} onClose={onClose}>
      <Dialog
        type="drawer"
        isOpen={isOpen}
        className={classes.chatContainer}
      >
        <ContestChat
          toggleChatAction={toggleChatAction}
          isSidePanel={false} // Mobile drawer (not side panel)
          onModalClose={onClose}
        />
      </Dialog>
    </DialogContainer>
  );
}
